// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Next__Atoms = require("../../../reason/next/Next__Atoms.bs.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var AgentInfo_agent_graphql = require("../../../__generated__/AgentInfo_agent_graphql.bs.js");
var TerminatedAgentIconOverlay = require("./TerminatedAgentIconOverlay.bs.js");

var convertFragment = AgentInfo_agent_graphql.Internal.convertFragment;

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentInfo_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentInfo_agent_graphql.node, convertFragment);
}

var AgentFragment_membershipStatusV5_decode = AgentInfo_agent_graphql.Utils.membershipStatusV5_decode;

var AgentFragment_membershipStatusV5_fromString = AgentInfo_agent_graphql.Utils.membershipStatusV5_fromString;

var AgentFragment = {
  membershipStatusV5_decode: AgentFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: AgentFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  use: use,
  useOpt: useOpt
};

function AgentInfo$FromAgent(props) {
  var size = props.size;
  var size$1 = size !== undefined ? size : "xSmall";
  var agent = RescriptRelay_Fragment.useFragment(AgentInfo_agent_graphql.node, convertFragment, props.agent);
  var brokerage;
  var displayName;
  var id;
  var profilePhoto;
  var match = agent.membershipStatus;
  var id$1 = agent.id;
  var displayName$1 = agent.displayName;
  var brokerage$1 = agent.brokerage;
  if (match === "ACTIVE") {
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  } else {
    if (match === "TERMINATED") {
      return React.createElement(TerminatedAgentIconOverlay.make, {
                  size: size$1,
                  children: React.createElement(AgentInfo__Jsx3.make, {
                        avatar: AvatarSrcUrl.place_holder,
                        brokerage: "NO LONGER ON TAN",
                        size: size$1,
                        name: displayName$1
                      })
                });
    }
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  }
  var avatar = profilePhoto !== undefined ? profilePhoto.url : AvatarSrcUrl.place_holder;
  return React.createElement(AgentInfo__Jsx3.make, {
              avatar: avatar,
              brokerage: brokerage,
              size: size$1,
              name: displayName,
              wrapName: (function (name) {
                  return React.createElement(Next__Atoms.Link.make, {
                              href: "/agents/" + id + "",
                              onClick: (function (e) {
                                  e.stopPropagation();
                                }),
                              children: React.createElement("div", {
                                    className: CssJs.style([CssJs.fontWeight({
                                                NAME: "num",
                                                VAL: 500
                                              })])
                                  }, name)
                            });
                }),
              children: Caml_option.some(null)
            });
}

var FromAgent = {
  make: AgentInfo$FromAgent
};

function AgentInfo$FromAgentOpt(props) {
  var agent = props.agent;
  if (agent !== undefined) {
    return React.createElement(AgentInfo$FromAgent, {
                agent: Caml_option.valFromOption(agent),
                size: props.size
              });
  } else {
    return null;
  }
}

var FromAgentOpt = {
  make: AgentInfo$FromAgentOpt
};

var make = AgentInfo$FromAgent;

exports.AgentFragment = AgentFragment;
exports.FromAgent = FromAgent;
exports.FromAgentOpt = FromAgentOpt;
exports.make = make;
/* CssJs Not a pure module */
